import { afterNextRender, Component, DestroyRef, inject, input, signal } from '@angular/core';

import { Cover } from '../../model/cover';
import { UrlLinkDirective } from '../url-link.directive';

@Component({
  selector: 'cover-slider',
  imports: [UrlLinkDirective],
  host: {
    style: 'display: contents'
  },
  template: `
    <div class="wrap-slick1">
      <div class="slick1">
        @for (cover of covers(); track $index; let index = $index, first = $first) {
          <div class="item-slick1" [class.active]="index === current()"
            [attr.aria-hidden]="index === current() ? null : 'true'"
            [style.background-image]="'url(' + cover.photo + ')'">
            <div class="wrap-content-slide1 sizefull flex-col-c-m p-l-15 p-r-15 p-t-150 p-b-170">
              <h2 class="caption1-slide1 m-text1 t-center animated m-b-15"
                [class.fadeInDown]="shown(index, 1)"
                [class.visible-true]="shown(index, 1)"
                [class.visible-false]="!shown(index, 1)">
                {{cover.text}}
              </h2>

              <!-- The title is an h1 on the first slide and an h2 on the rest, so the page has a single h1 -->
              @if (first) {
                <h1 class="caption2-slide1 xl-text1 t-center animated m-b-37"
                  [class.fadeInUp]="shown(index, 2)"
                  [class.visible-true]="shown(index, 2)"
                  [class.visible-false]="!shown(index, 2)">
                  {{cover.title}}
                </h1>
              } @else {
                <h2 class="caption2-slide1 xl-text1 t-center animated m-b-37"
                  [class.fadeInUp]="shown(index, 2)"
                  [class.visible-true]="shown(index, 2)"
                  [class.visible-false]="!shown(index, 2)">
                  {{cover.title}}
                </h2>
              }

              <div class="wrap-btn-slide1 w-size1 animated"
                [class.zoomIn]="shown(index, 3)"
                [class.visible-true]="shown(index, 3)"
                [class.visible-false]="!shown(index, 3)">
                <!-- Button -->
                <a class="flex-c-m size2 bo-rad-23 s-text2 bgwhite hov1 trans-0-4" [storefrontUrl]="cover.clickUrl">
                  Купити Зараз
                </a>
              </div>
            </div>
          </div>
        }
      </div>

      @if (covers().length > 1) {
        <button class="arrow-slick1 prev-slick1" type="button" aria-label="Попередній слайд"
          (click)="go(-1)">
          <i class="fa fa-angle-left" aria-hidden="true"></i>
        </button>
        <button class="arrow-slick1 next-slick1" type="button" aria-label="Наступний слайд"
          (click)="go(1)">
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </button>
      }
    </div>
    `
})
export class CoverSliderComponent {

  private static readonly INTERVAL = 6000;
  private static readonly STAGES = [200, 1000, 1800];

  readonly covers = input.required<Cover[]>();

  readonly current = signal(0);
  private stage = signal(0);
  private timers: ReturnType<typeof setTimeout>[] = [];

  constructor() {
    const destroyRef = inject(DestroyRef);
    afterNextRender(() => {
      this.stagger();
      if (this.covers().length < 2) {
        return;
      }
      const rotation = setInterval(() => this.go(1), CoverSliderComponent.INTERVAL);
      destroyRef.onDestroy(() => {
        clearInterval(rotation);
        this.timers.forEach(clearTimeout);
      });
    });
  }

  shown(index: number, stage: number): boolean {
    return index === this.current() && this.stage() >= stage;
  }

  go(direction: number): void {
    const count = this.covers().length;
    this.current.update(index => (index + direction + count) % count);
    this.stagger();
  }

  private stagger(): void {
    this.timers.forEach(clearTimeout);
    this.stage.set(0);
    this.timers = CoverSliderComponent.STAGES.map((delay, index) =>
      setTimeout(() => this.stage.set(index + 1), delay));
  }

}
